module.exports = __webpack_public_path__ + "img/abstract-shapes-15.f3858ac2.svg";